module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-and-press-item grid grid__base",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "grid--row news-and-press-item--row"
  }, [_c('div', {
    staticClass: "grid--col news-and-press-item--type"
  }, [_c('span', {
    staticClass: "news-and-press-item--type-label",
    domProps: {
      "textContent": _vm._s(_vm.articleTypeLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid--col news-and-press-item--img"
  }, [_c('div', {
    staticClass: "news-and-press-item--img-inner"
  }, [(_vm.imageData.src) ? _c('img', _vm._b({
    staticClass: "news-and-press-item--img-el"
  }, 'img', _vm.imageData, false)) : _c('div', {
    staticClass: "news-and-press-item--img-placeholder"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid--col news-and-press-item--data"
  }, [_c('div', {
    staticClass: "news-and-press-item--data-inner"
  }, [_c('time', {
    staticClass: "news-and-press-item--time",
    domProps: {
      "textContent": _vm._s(_vm.article.publication_date)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "news-and-press-item--title",
    domProps: {
      "textContent": _vm._s(_vm.article.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "news-and-press-item--lead",
    domProps: {
      "innerHTML": _vm._s(_vm.article.lead)
    }
  }), _vm._v(" "), (_vm.article.link) ? _c('div', {
    staticClass: "grid--row news-and-press-item--btn-row"
  }, [_c('div', {
    staticClass: "grid--col news-and-press-item--btn-col"
  }, [_c('cmp-rich-button', {
    attrs: {
      "plugin": _vm.article.link
    }
  })], 1)]) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5bbe2e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5bbe2e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/news-and-press-item/index.vue
// module id = 583
// module chunks = 7